import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const getCurrenciesFunc = createAsyncThunk(
  "currencies/getAll",
  async () => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/user/currencies`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => {
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const getCurrenciesSlicer = createSlice({
  name: "get currencies Slicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrenciesFunc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCurrenciesFunc.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "fetched successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(getCurrenciesFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default getCurrenciesSlicer.reducer;
